class HbsYatakTanimDTO {
    id: number = 0;
    yatakGrupId?: number = null;
    adi?: string = "";
    yatakTipi?: number = null;
    katNo?: number = null;
    odaNo?: number = null;
    yatakNo?: number = null;
    aktif?: string = "E";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
}
export default HbsYatakTanimDTO;